import { Config } from "../Config";
export const apiServicesUrl = Config.apiServerUrl;
